// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { createReducer } from '@reduxjs/toolkit';
import { WIZARD_TWINGRAPH_QUERIES } from './WizardConstants';

const initialState = {
  status: 'IDLE',
};

export const wizardReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(WIZARD_TWINGRAPH_QUERIES.PROCESS_TECHNICAL_POLICY_TWINGRAPH_QUERIES, (state, action) => {
      const { scenarioId, result, key, gisementName } = action.payload;
      state[scenarioId].technicalPolicy.gisements[gisementName][key] = result;
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.PROCESS_AGING_LAWS_TWINGRAPH_QUERIES, (state, action) => {
      const { scenarioId, result, key } = action.payload;
      if (state[scenarioId]) {
        if (state[scenarioId].agingLaws) Object.assign(state[scenarioId].agingLaws, { [key]: result });
        else Object.assign(state[scenarioId], { agingLaws: { [key]: result } });
      } else {
        Object.assign(state, { [scenarioId]: { agingLaws: { [key]: result } } });
      }
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.SET_TWINGRAPH_QUERIES_STATUS, (state, action) => {
      state.status = action.status;
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.ADD_TECHNICAL_VAR, (state, action) => {
      const { techVar, scenarioId } = action.payload;
      state[scenarioId].technicalVars = { ...state[scenarioId].technicalVars, ...techVar };
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.RESET_TECHNICAL_VARS, (state, action) => {
      const { scenarioId } = action.payload;
      state[scenarioId].technicalVars = {};
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.SET_GANTT_QUERIES_RESULTS, (state, action) => {
      const { scenarioId, technicalPolicy } = action.payload;
      Object.assign(state, { [scenarioId]: { technicalPolicy } });
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.SET_NEW_TABLES_MAPPING, (state, action) => {
      const { scenarioId, gisement, tableNamesMapping } = action.payload;
      if (!state[scenarioId].technicalPolicy.gisements[gisement]) {
        state[scenarioId].technicalPolicy.gisements[gisement] = {};
      }
      state[scenarioId].technicalPolicy.gisements[gisement].tableNamesMapping = tableNamesMapping;
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.UPDATE_TECHNICAL_POLICY, (state, action) => {
      const { scenarioId, key, data } = action.payload;
      Object.assign(state[scenarioId].technicalPolicy, { [key]: data });
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.PROCESS_DATA_VECTOR_TWINGRAPH_QUERIES, (state, action) => {
      const { scenarioId, result } = action.payload;
      if (state[scenarioId]) {
        state[scenarioId].dataVector = result;
      } else {
        Object.assign(state, { [scenarioId]: { dataVector: result } });
      }
    })
    .addCase(WIZARD_TWINGRAPH_QUERIES.DELETE_GISEMENT, (state, action) => {
      const { scenarioId, gisementName } = action.payload;
      if (state[scenarioId]?.technicalPolicy?.gisements?.[gisementName]) {
        delete state[scenarioId].technicalPolicy.gisements[gisementName];
      }
    });
});
